export default __webpack_public_path__ + "b1b511ca30c67c3b0655373f02a6daf6.jpg";